module.exports = __webpack_public_path__ + "static/media/breadcrumb.e08c6ff7.svg";